<div
  class="product-carousel__container"
  test-target="product-carousel-container"
>
  <div (next)="trackRightSwipe()"
       (previous)="trackLeftSwipe()"
       *ngIf="isMobile"
       [ngClass]="{'product-carousel__mobile__noborder': noBorder}"
       appSwipe
       class="product-carousel__mobile">
    <ng-container *ngFor="let product of products; trackBy: trackById; let i=index;">
      <app-search-product-card (productClick)="onProductClick($event.product, $event.priceType, i)"
                               *ngIf="!(isVariantsRedesignEnabled$ | async); else productCardVariants"
                               [isBlackDealsEnabled]="(isBlackDealsEnabled$ | async)"
                               [isDesktop]="isDesktop"
                               [isProductList]="false"
                               [isSimilarProductRecommendation]="isSimilarProductRecommendation"
                               [ngClass]="{'product-carousel__card__noborder': noBorder}"
                               [product]="product"
                               class="product-carousel__card old__card"
                               test-target="product-carousel-item-mobile"
      >
      </app-search-product-card>
      <ng-template #productCardVariants>
        <app-search-product-card-variants
          (productClick)="onProductClick($event.product, $event.priceType, i)"
          [addToCartConfig]="addToCartConfig"
          [isBlackDealsEnabled]="(isBlackDealsEnabled$ | async)"
          [isDesktop]="isDesktop"
          [isMobileOrTablet]="isMobile"
          [isProductList]="false"
          [isSimilarProductRecommendation]="isSimilarProductRecommendation"
          [ngClass]="{'product-carousel__card__noborder': noBorder}"
          [product]="product"
          [shouldSaveSpaceForVariants]="someProductHasVariants()"
          class="product-carousel__card"
          test-target="product-carousel-item-mobile"
        >
        </app-search-product-card-variants>
      </ng-template>
    </ng-container>
  </div>
  <div *ngIf="!isMobile" class="product-carousel__desktop">
        <span
          (click)="productCarousel.prev() || onProductCarouselPrev()"
          *ngIf="carouselOverflow !== 'overflowRight'"
          [mmTestTarget]="'product-carousel-carousel-prev-button'"
          [ngClass]="{'product-carousel__arrow_newStyle': (isVariantsRedesignEnabled$ | async)}"
          class="product-carousel__arrow"
        >
          <ng-container *ngIf="!(isVariantsRedesignEnabled$ | async); else newCarouselLeftIcon">
        <app-svg-chevron-left class="product-carousel__arrow-icon"
        ></app-svg-chevron-left>
      </ng-container>
      <ng-template #newCarouselLeftIcon class="product-carousel__arrow_newStyle">
        <mm-icon name="chevron-small-left"></mm-icon>
      </ng-template>
        </span>
    <owl-carousel-o #productCarousel
      (translated)="onCarouselMove()"
      *ngIf="!(isVariantsRedesignEnabled$ | async); else variantsCarousel"
      [ngClass]="{
        'overflowLeft': carouselOverflow === 'overflowLeft',
        'overflowRight': carouselOverflow === 'overflowRight' || carouselOverflow === ''
      }"
      [options]="customCarouselOptions"
    >
      <ng-container *ngFor="let product of products; trackBy: trackById; let i=index;">
        <ng-template carouselSlide>
          <app-search-product-card (productClick)="onProductClick($event.product, $event.priceType, i)"
                                            [isBlackDealsEnabled]="(isBlackDealsEnabled$ | async)"
                                            [isDesktop]="isDesktop"
                                            [isProductList]="false"
                                            [isSimilarProductRecommendation]="isSimilarProductRecommendation"
                                            [ngClass]="{'product-carousel__card__noborder': noBorder}"
                                            [product]="product"
                                            class="product-carousel__card old__card"
                                            test-target="product-carousel-item-mobile"
          >
          </app-search-product-card>
        </ng-template>
      </ng-container>
    </owl-carousel-o>
    <ng-template #variantsCarousel>
      <owl-carousel-o
        #productCarousel
                      (translated)="onCarouselMove()"
                      [ngClass]="{
        'overflowLeft': carouselOverflow === 'overflowLeft',
        'overflowRight': carouselOverflow === 'overflowRight' || carouselOverflow === ''
      }"
                      [options]="customCarouselOptions"
                      class="new-product-card-style"
      >
        <ng-container *ngFor="let product of products; trackBy: trackById; let i=index;">
          <ng-template carouselSlide>
            <app-search-product-card-variants (productClick)="onProductClick($event.product, $event.priceType, i)"
                                              [addToCartConfig]="addToCartConfig"
                                              [isBlackDealsEnabled]="(isBlackDealsEnabled$ | async)"
                                              [isDesktop]="isDesktop"
                                              [isMobileOrTablet]="!isDesktop"
                                              [isProductList]="false"
                                              [isSimilarProductRecommendation]="isSimilarProductRecommendation"
                                              [ngClass]="{'product-carousel__card__noborder': noBorder}"
                                              [productIndex]="i"
                                              [product]="product"
                                              [saveTotalUnitsOrBasePriceSpace]="someProductsHasTotalUnitsOrBasePrice()"
                                              [shouldSaveSpaceForVariants]="someProductHasVariants()"
                                              class="product-carousel__card"
                                              test-target="product-carousel-item-mobile"
            >
            </app-search-product-card-variants>
          </ng-template>
        </ng-container>
      </owl-carousel-o>
    </ng-template>
    <span
      (click)="productCarousel.next() || onProductCarouselNext()"
      *ngIf="showRightArrow"
      [mmTestTarget]="'product-carousel-carousel-next-button'"
      [ngClass]="{
        'product-carousel__arrow_newStyle': (isVariantsRedesignEnabled$ | async),
        '--gt5': productCarousel?.slidesData?.length > 5,
        '--gt3': productCarousel?.slidesData?.length > 3
      }"
      class="product-carousel__arrow product-carousel__arrow-right"
    >
     <ng-container *ngIf="!(isVariantsRedesignEnabled$ | async); else newCarouselRightIcon">
        <app-svg-chevron-right class="product-carousel__arrow-icon"></app-svg-chevron-right>
      </ng-container>
      <ng-template #newCarouselRightIcon class="product-carousel__arrow_newStyle">
        <mm-icon name="chevron-small-right"></mm-icon>
      </ng-template>
    </span>
  </div>
</div>
